import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { Store } from 'store';
import getDesignsFromFamilies from 'utils/family/getDesignsFromFamilies';
import isServer from 'utils/isServer';
import getCategories from '../selector/getCategories';
import fetchGTMProductsDataOperation from './fetchGTMProductsDataOperation';

const fetchGTMProductsDataForCurrentDesignsOperation =
  () => async (dispatch: ThunkDispatch<Store, undefined, AnyAction>, getState: () => Store) => {
    if (isServer()) {
      return;
    }

    const store = getState();
    const designFamilies = getCategories(store)?.families || [];
    const designs = getDesignsFromFamilies(designFamilies);
    const designIds = designs.map((design) => design.designIdEncrypted);

    await dispatch(fetchGTMProductsDataOperation(designIds));
  };

export default fetchGTMProductsDataForCurrentDesignsOperation;
